'use strict';
module.exports = require('../full/parse-int');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/parse-int.js
// module id = 611
// module chunks = 13